<template lang="pug">
  router-view
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>
